import type { Branch } from '@/types/api'
import { createCrudService } from '../crud'

export type BranchInput = Pick<
  Branch,
  | 'parent_branch_id'
  | 'location_id'
  | 'type_code'
  | 'code'
  | 'name_en'
  | 'name_ru'
  | 'name_uz'
  | 'name_cyr'
  | 'address'
  | 'timezone'
  | 'status'
>

export const branchesService = createCrudService<Branch, BranchInput, Partial<BranchInput>>('branches')
